<template>
  <div v-if='$can("Administrator")' class="animated fadeIn" v-loading="isLoading">
    <el-row type="flex" justify="center">
      <el-col  class="pl-1 pr-1 mb-2"
               @click.native="itemSelected = item.component"
               v-for="item in listCompetents"
               :key="item.id">
        <dash-item-menu :title="item.label"
                        :selected="item.component === itemSelected"
                        :key="item.id"/>
      </el-col>
    </el-row>
    <transition name="fade"  mode="out-in">
      <keep-alive>
        <component :is="itemSelected"></component>
      </keep-alive>
    </transition>

  </div>
</template>

<script>
  import DashItemMenu from './DashItemMenu'
  import Periodo from './Components/Periodo'
  import Ranking from './Components/Ranking'
  import Resposta from './Components/Resposta'

  import Home from './Components/Home'
  import {MessageBox} from 'element-ui'
  import {mapActions, mapState} from "vuex"

  export default {
    name: 'dashboard',
    components: {DashItemMenu, MessageBox, Home, Periodo, Resposta, Ranking},
    data() {
      return {
        isLoading: false,
        itemSelected: 'Home',
        listCompetents: [
          {component: 'Home', label: 'Inicio'},
          {component: 'Periodo', label: 'Analítico'},
          {component: 'Ranking', label: 'Ranking'},
          {component: 'Resposta', label: 'Respostas'},
        ]
      }
    },
    computed: {
      ...mapState('Dashboard', ['dados']),
      ...mapState(['periodoSelected', 'competenciaSelected', 'centroCustoSelected']),
    },
    methods: {
      ...mapActions('Dashboard', ['setDados'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/features/Dashboard/index.vue